import "./WikiModal.css";

function WikiModal({ page }) {
  return (
    <div className="wiki-modal-container">
      <iframe
        className="wiki-modal-iframe"
        src={`https://en.wikipedia.org/wiki/${page}`}
        title={page}
      />
    </div>
  );
}

export default WikiModal;
